import { SignedIn, SignedOut, SignUp } from "@clerk/clerk-react";
import { t } from "@lingui/macro";
import { Helmet } from "react-helmet-async";
import { Navigate, useLocation } from "react-router-dom";

import { env } from "@/client/config/env";

import { useAuthRedirect, withAuthQuery } from "../auth-redirect";
import { SignedInRedirect } from "../login/clerk-page";
import { PlanIntentSummary } from "../plan-intent-summary";

export const ClerkRegisterPage = () => {
  const { search } = useLocation();
  const redirectUrl = useAuthRedirect();

  if (env.VITE_DISABLE_SIGNUPS) {
    return <Navigate to={withAuthQuery("/auth/login", search)} replace />;
  }

  return (
    <div>
      <Helmet>
        <title>
          {t`Create your account`} - {t`theResume`}
        </title>
      </Helmet>

      <SignedIn>
        <SignedInRedirect to={redirectUrl} />
      </SignedIn>

      <SignedOut>
        <header className="mb-8">
          <h2 className="max-w-[15ch] text-[2rem] font-semibold leading-[1.12] -tracking-wide text-slate-950 [text-wrap:balance] sm:text-[2.25rem]">
            {t`Create a career workspace that is yours.`}
          </h2>
          <p className="mt-3 text-base leading-relaxed text-slate-500">
            {t`Build, practice, and keep your career story in one place.`}
          </p>
        </header>

        <PlanIntentSummary redirect={redirectUrl} mode="signup" />

        {/* forceRedirectUrl, not a fallback: see the sign-in page. */}
        <SignUp
          routing="virtual"
          signInUrl={withAuthQuery("/auth/login", search)}
          forceRedirectUrl={redirectUrl}
          signInForceRedirectUrl={redirectUrl}
        />
      </SignedOut>
    </div>
  );
};
